import { BaseCriteriaDtoModel } from "../../../services";

export class GenericDocLineRecentItemDto extends BaseCriteriaDtoModel{
    item_guid: string;
    guid_comp: string;
    server_doc_type: string;
    doc_entity_hdr_guid: string;
    limit: number;
    order: string;


    constructor(
        item_guid?: string,
        guid_comp?: string,
        server_doc_type?: string,
        doc_entity_hdr_guid?: string,
        limit?: number,
        order?: string
    ) {
        super();
        this.item_guid = item_guid ? item_guid : '';
        this.guid_comp = guid_comp ? guid_comp : '';
        this.server_doc_type = server_doc_type ? server_doc_type : '';
        this.doc_entity_hdr_guid = doc_entity_hdr_guid ? doc_entity_hdr_guid : '';
        this.limit = limit ? limit : 10;
        this.order = order ? order : 'DESC';
    }

    getItemGuid(): string {
        return this.item_guid;
    }

    setItemGuid(item_guid: string) {
        this.item_guid = item_guid;
    }

    getGuidComp(): string {
        return this.guid_comp;
    }

    setGuidComp(guid_comp: string) {
        this.guid_comp = guid_comp;
    }

    getServerDocType(): string {
        return this.server_doc_type;
    }

    setServerDocType(server_doc_type: string) {
        this.server_doc_type = server_doc_type;
    }

    getDocEntityHdrGuid(): string {
        return this.doc_entity_hdr_guid;
    }

    setDocEntityHdrGuid(doc_entity_hdr_guid: string) {
        this.doc_entity_hdr_guid = doc_entity_hdr_guid;
    }

    getQueryKeyValues() {
        let queryString = `limit=${this.limit}`;

        if (this.item_guid) {
            queryString += `&item_guid=${this.item_guid}`;
        }

        if (this.guid_comp) {
            queryString += `&guid_comp=${this.guid_comp}`;
        }

        if (this.server_doc_type) {
            queryString += `&server_doc_type=${this.server_doc_type}`;
        }

        if (this.doc_entity_hdr_guid) {
            queryString += `&doc_entity_hdr_guid=${this.doc_entity_hdr_guid}`;
        }

        if (this.order) {
            queryString += `&order=${this.order}`;
        }

        return queryString;
    }
}